module.exports = __webpack_public_path__ + "img/Superb_sword_16.d34de273.png";